import { PropertyKey } from '../../language/PropertyKey';

export const LOG_FORMAT_KEY = Symbol('LOG_FORMAT_KEY');

export const getLogFormats = (
  target: any,
  property: PropertyKey
): Map<number, string> => {
  const formats = Reflect.getOwnMetadata(LOG_FORMAT_KEY, target, property);

  if (!formats) {
    return new Map();
  }

  return formats;
};

export const LogFormat =
  (format: string) =>
  (target: any, property: PropertyKey, parameterIndex: number): void => {
    const formats = getLogFormats(target, property);

    formats.set(parameterIndex, format);
    Reflect.defineMetadata(LOG_FORMAT_KEY, formats, target, property);
  };
